import type { ActionItemDraft } from '../types.ts';
import { notesBlockReviewProjectionAdapter } from './notes.ts';
import { transcriptSegmentReviewProjectionAdapter } from './transcripts.ts';
import type {
  ActionItemDraftReviewProjection,
  ActionItemDraftReviewProjectionAdapter,
} from './types.ts';

const actionItemDraftReviewProjectionAdapters: readonly ActionItemDraftReviewProjectionAdapter[] =
  Object.freeze([
    notesBlockReviewProjectionAdapter,
    transcriptSegmentReviewProjectionAdapter,
  ]);

export interface ActionItemDraftReviewProjectionInspection {
  supported: boolean;
  projection: ActionItemDraftReviewProjection | null;
}

export function inspectActionItemDraftReviewProjection(
  draft: ActionItemDraft,
): ActionItemDraftReviewProjectionInspection {
  const matchingAdapters = actionItemDraftReviewProjectionAdapters.filter(
    adapter => adapter.adapterId === draft.evidenceBlock.sourceType,
  );
  const projections = matchingAdapters.flatMap(adapter => {
    const projection = adapter.project(draft);
    return projection === null ? [] : [projection];
  });
  return {
    supported: matchingAdapters.length > 0,
    projection: projections.length === 1 ? projections[0] ?? null : null,
  };
}

export function projectActionItemDraftReview(
  draft: ActionItemDraft,
): ActionItemDraftReviewProjection | null {
  return inspectActionItemDraftReviewProjection(draft).projection;
}
